// extracted by mini-css-extract-plugin
export default {"container":"hawk-model-code-reviews-container","userReviews":"hawk-model-code-reviews-userReviews"};